exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#devmg[data-v-47e449e8]{padding-top:20px;width:100%}.el-table[data-v-47e449e8]{margin:20px}.el-table .warning-row[data-v-47e449e8]{background:oldlace}.el-table .success-row[data-v-47e449e8]{background:#f0f9eb}.edit_dev[data-v-47e449e8]{text-align:left}.edit_dev[data-v-47e449e8] .el-transfer-panel{width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47e449e8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/device_Mg.vue
// module id = 251
// module chunks = 0